import {
  GET_CHATS_SUCCESS,
  SAVE_CHATS_SUCCESS,
  RESET_CHATS,
  GET_CHATS_COUNTS_SUCCESS,
  GET_CHATS_PENDING,
  GET_CHATS_FAILURE,
} from './chatTypes';

const initialState = {
  chats: [],
  chatCount: 0,
  isLoading: false,
  error: false,
  errorCode: null,
};

const ChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHATS_PENDING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case GET_CHATS_SUCCESS: {
      let chatAllowSpecialChars= action.chatAllowSpecialChars;
      let additionalRestriction= ["<",">","^","$","\\[","\\]","*"]; 
      additionalRestriction.filter((item,index)=> {let findList=chatAllowSpecialChars.indexOf(item)
        if(findList>-1){
          additionalRestriction.splice(index,1);
        }
      })
      return {
        ...state,
        chats: action.chats,
        chatAllowSpecialChars: action.chatAllowSpecialChars,
        chatAllowValidationSpecialChars: action.chatAllowValidationSpecialChars,
        additionalCharRestict: additionalRestriction,
        isLoading: false,
      };
    }
    case GET_CHATS_FAILURE: {
      return {
        ...state,
        chats: [],
        error: true,
        errorCode: action.error,
        isLoading: false,
      };
    }
    case RESET_CHATS: {
      return {
        ...state,
        chats: [],
        error: false,
        isLoading: false,
        errorCode: null,
      };
    }
    case SAVE_CHATS_SUCCESS: {
      return {
        ...state,
        chats: action.chats,
      };
    }
    case GET_CHATS_COUNTS_SUCCESS: {
      return {
        ...state,
        chatCount: action.data.chatCount,
      };
    }

    default:
      return state;
  }
};

export default ChatReducer;



// WEBPACK FOOTER //
// ./src/ui/features/Chat/state/chatReducer.js